import fetchClient from './configuration';
import { getUrl, routeAPI } from './constants';

class ConsignorAPI {
  static async getConsignors() {
    const url = getUrl(routeAPI.CONSIGNORS);
    const res = await fetchClient.get(url);
    return res.data;
  }

  static async getConsignor(consignorID) {
    const url = getUrl(`${routeAPI.CONSIGNORS}/${consignorID}`);
    const res = await fetchClient.get(url);
    return res.data;
  }

  static async saveConsignor(consignor, isNew) {
    const url = getUrl(`${routeAPI.CONSIGNORS}`);
    let res;
    if (isNew) {
      res = await fetchClient.post(url, consignor);
    } else {
      res = await fetchClient.put(url, consignor);
    }
    return res.data;
  }
}
export default ConsignorAPI;
